import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  const breadcrumbs: { label: string; href: string }[] = [
    { label: '首页', href: '/' },
  ];

  if (pathParts[0] === 'category' && pathParts[1]) {
    const cat = categories.find(c => c.slug === pathParts[1]);
    breadcrumbs.push({ label: cat ? cat.name : '分类', href: '/category/' + pathParts[1] });
  } else if (pathParts[0] === 'article') {
    breadcrumbs.push({ label: '漫画详情', href: '#' });
  } else if (pathParts[0] === 'about') {
    breadcrumbs.push({ label: '关于我们', href: '/about' });
  }

  if (breadcrumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-600">
          {breadcrumbs.map((crumb, index) => (
            <li key={crumb.href} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400">/</span>
              )}
              {index < breadcrumbs.length - 1 ? (
                <Link
                  to={crumb.href}
                  className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-900 font-medium whitespace-nowrap">
                  {crumb.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}